import classNames from 'classnames';
import { Tariffs } from '../../home';
import styles from './styles.module.scss';

const TariffsBlock = ({ tariffs }) => {
  const renderTariff = (item, index) => {
    return (
      item.tariffs && (
        <Tariffs
          data={item.tariffs}
          key={index}
          title={item.title}
          itemScope
          itemType='http://schema.org/ListItem'
        />
      )
    );
  };

  return (
    <div
      className={classNames([styles.container, 'little-margin'])}
      itemScope
      itemType='http://schema.org/ItemList'
    >
      {tariffs && tariffs.map(renderTariff)}
    </div>
  );
};

export default TariffsBlock;
